
define('unknown/models/pwActKeyModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var PwActKey = Backbone.Model.extend({
		urlRoot:"/draftapp/users/pwreset",
		idAttribute: 'key',
		defaults: {
	    	key: null,
	    	activationType: null,
	    	password: null
	    },

	    initialize: function() {
	    	
	    },

	    isActivated: function() {
	    	return this.get("activated") > 0;
	    },	
	});
	
	return PwActKey;  
});